<div
  class="modal-header"
  cdkDrag
  cdkDragRootElement=".modal-dialog"
  [cdkDragDisabled]="!movable"
  [class.movable-modal-header]="movable"
>
  <div class="d-flex align-items-center gap-2">
    <i *ngIf="movable" class="fas fa-grip-vertical movable-drag-icon"></i>
    <div>
      <h5 class="modal-title mt-0" translate>ORDER_AND_OFFER_DATA</h5>
      <small class="text-muted">{{ productId }}<span *ngIf="productName"> – {{ productName }}</span></small>
    </div>
  </div>
  <button type="button" class="close" (click)="activeModal.dismiss()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body modal-body--fixed d-flex flex-column p-0">
  <div *ngIf="loading" class="text-center py-5">
    <div class="sk-wandering-cubes">
      <div class="sk-cube bg-primary sk-cube-1"></div>
      <div class="sk-cube bg-primary sk-cube-2"></div>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <nav ngbNav #nav="ngbNav" [(activeId)]="activeNavId" class="nav-tabs flex-shrink-0 px-3 pt-2">
      <ng-container [ngbNavItem]="'orders'">
        <a ngbNavLink translate>ORDERS</a>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column h-100">
            <div class="flex-shrink-0 px-3 pt-2 pb-1 border-bottom">
              <input type="text" class="form-control form-control-sm" [placeholder]="'SEARCH_CUSTOMER' | translate" [value]="orderSearch" (input)="filterOrders($any($event.target).value)" />
              <div class="d-flex gap-2 align-items-center mt-2">
                <div class="input-group input-group-sm flex-fill">
                  <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  <input type="date" class="form-control form-control-sm" [placeholder]="'DATE_FROM' | translate" [value]="orderDateFrom" (input)="filterOrdersByDate($any($event.target).value, orderDateTo)" />
                </div>
                <span class="text-muted px-1">–</span>
                <div class="input-group input-group-sm flex-fill">
                  <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  <input type="date" class="form-control form-control-sm" [placeholder]="'DATE_TO' | translate" [value]="orderDateTo" (input)="filterOrdersByDate(orderDateFrom, $any($event.target).value)" />
                </div>
                <button *ngIf="orderDateFrom || orderDateTo" type="button" class="btn btn-sm btn-outline-secondary" (click)="filterOrdersByDate('', '')" title="{{ 'CLEAR' | translate }}">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div class="flex-grow-1 overflow-auto px-3 pb-2">
              <table class="table table-sm table-hover mb-0 order-offer-table">
                <colgroup>
                  <col style="width: 13%" />
                  <col style="width: 13%" />
                  <col style="width: 28%" />
                  <col style="width: 10%" />
                  <col style="width: 13%" />
                  <col style="width: 12%" />
                  <col style="width: 11%" />
                </colgroup>
                <thead>
                  <tr>
                    <th translate>ORDER_NUMBER</th>
                    <th translate>CUSTOMER_NUMBER</th>
                    <th translate>CUSTOMER_NAME</th>
                    <th class="sortable-col" (click)="sortOrders('qty')">
                      {{ 'QUANTITY' | translate }}
                      <i class="fa ms-1" [ngClass]="orderSortCol === 'qty' ? (orderSortDir === 'asc' ? 'fa-sort-up text-primary' : 'fa-sort-down text-primary') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="sortable-col" (click)="sortOrders('date')">
                      {{ 'DATE' | translate }}
                      <i class="fa ms-1" [ngClass]="orderSortCol === 'date' ? (orderSortDir === 'asc' ? 'fa-sort-up text-primary' : 'fa-sort-down text-primary') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="sortable-col" (click)="sortOrders('unitPrice')">
                      {{ 'UNIT_PRICE' | translate }}
                      <i class="fa ms-1" [ngClass]="orderSortCol === 'unitPrice' ? (orderSortDir === 'asc' ? 'fa-sort-up text-primary' : 'fa-sort-down text-primary') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="sortable-col" (click)="sortOrders('price')">
                      {{ 'PRICE' | translate }}
                      <i class="fa ms-1" [ngClass]="orderSortCol === 'price' ? (orderSortDir === 'asc' ? 'fa-sort-up text-primary' : 'fa-sort-down text-primary') : 'fa-sort text-muted'"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of orders">
                    <td><a class="text-primary" style="cursor:pointer" (click)="openOrderDetail(row.orderId)">{{ row.orderId }}</a></td>
                    <td>{{ row.customerId }}</td>
                    <td>{{ row.customerName }}</td>
                    <td>{{ row.orderRowTotalQuantity }}</td>
                    <td>{{ row.orderCreationDate | date: 'yyyy-MM-dd' }}</td>
                    <td>{{ row.orderRowTotalValueCurrency / row.orderRowTotalQuantity | number: '1.2-2' }} {{ getCurrencyCode(row) }}</td>
                    <td>{{ row.orderRowTotalValueCurrency | number: '1.2-2' }} {{ getCurrencyCode(row) }}</td>
                  </tr>
                  <tr *ngIf="orders.length === 0">
                    <td colspan="7" class="text-center text-muted" translate>NO_DATA</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <ng-container [ngbNavItem]="'offers'">
        <a ngbNavLink translate>OFFERS</a>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column h-100">
            <div class="flex-shrink-0 px-3 pt-2 pb-1 border-bottom">
              <input type="text" class="form-control form-control-sm" [placeholder]="'SEARCH_CUSTOMER' | translate" [value]="offerSearch" (input)="filterOffers($any($event.target).value)" />
              <div class="d-flex gap-2 align-items-center mt-2">
                <div class="input-group input-group-sm flex-fill">
                  <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  <input type="date" class="form-control form-control-sm" [placeholder]="'DATE_FROM' | translate" [value]="offerDateFrom" (input)="filterOffersByDate($any($event.target).value, offerDateTo)" />
                </div>
                <span class="text-muted px-1">–</span>
                <div class="input-group input-group-sm flex-fill">
                  <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  <input type="date" class="form-control form-control-sm" [placeholder]="'DATE_TO' | translate" [value]="offerDateTo" (input)="filterOffersByDate(offerDateFrom, $any($event.target).value)" />
                </div>
                <button *ngIf="offerDateFrom || offerDateTo" type="button" class="btn btn-sm btn-outline-secondary" (click)="filterOffersByDate('', '')" title="{{ 'CLEAR' | translate }}">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div class="flex-grow-1 overflow-auto px-3 pb-2">
              <table class="table table-sm table-hover mb-0 order-offer-table">
                <colgroup>
                  <col style="width: 13%" />
                  <col style="width: 13%" />
                  <col style="width: 28%" />
                  <col style="width: 10%" />
                  <col style="width: 13%" />
                  <col style="width: 12%" />
                  <col style="width: 11%" />
                </colgroup>
                <thead>
                  <tr>
                    <th translate>OFFER_NUMBER</th>
                    <th translate>CUSTOMER_NUMBER</th>
                    <th translate>CUSTOMER_NAME</th>
                    <th class="sortable-col" (click)="sortOffers('qty')">
                      {{ 'QUANTITY' | translate }}
                      <i class="fa ms-1" [ngClass]="offerSortCol === 'qty' ? (offerSortDir === 'asc' ? 'fa-sort-up text-primary' : 'fa-sort-down text-primary') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="sortable-col" (click)="sortOffers('date')">
                      {{ 'DATE' | translate }}
                      <i class="fa ms-1" [ngClass]="offerSortCol === 'date' ? (offerSortDir === 'asc' ? 'fa-sort-up text-primary' : 'fa-sort-down text-primary') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="sortable-col" (click)="sortOffers('unitPrice')">
                      {{ 'UNIT_PRICE' | translate }}
                      <i class="fa ms-1" [ngClass]="offerSortCol === 'unitPrice' ? (offerSortDir === 'asc' ? 'fa-sort-up text-primary' : 'fa-sort-down text-primary') : 'fa-sort text-muted'"></i>
                    </th>
                    <th class="sortable-col" (click)="sortOffers('price')">
                      {{ 'PRICE' | translate }}
                      <i class="fa ms-1" [ngClass]="offerSortCol === 'price' ? (offerSortDir === 'asc' ? 'fa-sort-up text-primary' : 'fa-sort-down text-primary') : 'fa-sort text-muted'"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of offers">
                    <td><a class="text-primary" style="cursor:pointer" (click)="openOfferDetail(row.offerId)">{{ row.offerId }}</a></td>
                    <td>{{ row.customerId }}</td>
                    <td>{{ row.customerName }}</td>
                    <td>{{ row.offerRowTotalQuantity }}</td>
                    <td>{{ row.offerCreationDate | date: 'yyyy-MM-dd' }}</td>
                    <td>{{ row.offerRowTotalValueCurrency / row.offerRowTotalQuantity | number: '1.2-2' }} {{ getCurrencyCode(row) }}</td>
                    <td>{{ row.offerRowTotalValueCurrency | number: '1.2-2' }} {{ getCurrencyCode(row) }}</td>
                  </tr>
                  <tr *ngIf="offers.length === 0">
                    <td colspan="7" class="text-center text-muted" translate>NO_DATA</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </nav>

    <div [ngbNavOutlet]="nav" class="nav-outlet flex-grow-1 overflow-hidden d-flex flex-column"></div>
  </ng-container>
</div>

<div class="modal-footer order-offer-footer" *ngIf="!loading">
  <table class="table table-sm table-borderless mb-0 order-offer-table order-offer-total-table">
    <colgroup>
      <col style="width: 13%" />
      <col style="width: 13%" />
      <col style="width: 28%" />
      <col style="width: 10%" />
      <col style="width: 13%" />
      <col style="width: 12%" />
      <col style="width: 11%" />
    </colgroup>
    <tbody>
      <tr *ngIf="activeNavId === 'orders' && orders.length > 0" class="fw-bold">
        <td colspan="3" translate>TOTAL</td>
        <td>{{ orderSumQty }}</td>
        <td></td>
        <td></td>
        <td>{{ orderSumPrice | number: '1.2-2' }} {{ orderSumCurrency }}</td>
      </tr>
      <tr *ngIf="activeNavId === 'offers' && offers.length > 0" class="fw-bold">
        <td colspan="3" translate>TOTAL</td>
        <td>{{ offerSumQty }}</td>
        <td></td>
        <td></td>
        <td>{{ offerSumPrice | number: '1.2-2' }} {{ offerSumCurrency }}</td>
      </tr>
    </tbody>
  </table>
</div>
